import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../utils/options';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {houseFinishGradeOptions} from '../../../../../common/constants/options';
import styles from './styles.module.scss';

const Section6Text711 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {houseFinishGrade, houseFinishGradeDesc} = context.data.pdfData;
  const houseFinishGradeValue = getSelectedOptionLabel(houseFinishGrade, houseFinishGradeOptions);

  return (
    <div className={classnames(styles.itemText, styles.innerPadding)} ref={ref}>
      <span className={styles.bold}>רמת גמר: </span>
      <span>
        {houseFinishGradeValue}.
      </span>
      <span>
        {getBreakLinesTextShumaType3(houseFinishGradeDesc)}.
      </span>
    </div>
  );
});

export default Section6Text711;
